import { axios } from '@/utils/request'

/**
 * 查询医院不良事件表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventPage (parameter) {
  return axios({
    url: '/baAdverseEvent/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 医院不良事件表列表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventList (parameter) {
  return axios({
    url: '/baAdverseEvent/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加医院不良事件表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventAdd (parameter) {
  return axios({
    url: '/baAdverseEvent/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑医院不良事件表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventEdit (parameter) {
  return axios({
    url: '/baAdverseEvent/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除医院不良事件表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventDelete (parameter) {
  return axios({
    url: '/baAdverseEvent/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出医院不良事件表
 *
 * @author 张禹尧
 * @date 2023-04-06 11:35:30
 */
export function baAdverseEventExport (parameter) {
  return axios({
    url: '/baAdverseEvent/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
